var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 15.6661C10.9114 15.6661 10.8266 15.6309 10.7641 15.5684C10.7016 15.5059 10.6665 15.4211 10.6665 15.3327C10.6665 15.2443 10.7016 15.1595 10.7641 15.097C10.8266 15.0345 10.9114 14.9994 10.9998 14.9994",
    fill: "#C56A02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 15.6661C10.9114 15.6661 10.8266 15.6309 10.7641 15.5684C10.7016 15.5059 10.6665 15.4211 10.6665 15.3327C10.6665 15.2443 10.7016 15.1595 10.7641 15.097C10.8266 15.0345 10.9114 14.9994 10.9998 14.9994",
    stroke: "#C56A02",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 15.6661C11.0884 15.6661 11.1732 15.6309 11.2357 15.5684C11.2982 15.5059 11.3333 15.4211 11.3333 15.3327C11.3333 15.2443 11.2982 15.1595 11.2357 15.097C11.1732 15.0345 11.0884 14.9994 11 14.9994",
    stroke: "#C56A02",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11 12.3327V5.66602",
    stroke: "#C56A02",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.47106 12.138C1.16943 11.836 1 11.4266 1 10.9998C1 10.573 1.16943 10.1636 1.47106 9.86158L9.86222 1.47135C10.0116 1.32192 10.189 1.20338 10.3842 1.1225C10.5794 1.04163 10.7887 1 11 1C11.2113 1 11.4206 1.04163 11.6158 1.1225C11.811 1.20338 11.9884 1.32192 12.1378 1.47135L20.5289 9.86158C20.8306 10.1636 21 10.573 21 10.9998C21 11.4266 20.8306 11.836 20.5289 12.138L12.1378 20.5282C11.9884 20.6777 11.811 20.7962 11.6158 20.8771C11.4206 20.958 11.2113 20.9996 11 20.9996C10.7887 20.9996 10.5794 20.958 10.3842 20.8771C10.189 20.7962 10.0116 20.6777 9.86222 20.5282L1.47106 12.138Z",
    stroke: "#C56A02",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.8aa9cb71b4c3b413e76e5d359fa83d8f.svg";
export { ForwardRef as ReactComponent };